import { LocationApi } from '../api/apicollection';
import { formatAddress, formatPhoneNumber } from '../util/formatHelper';

export default function LayoutViewModel() {
    this.location = ko.observable();
    this.logoUrl = ko.observable();
    this.physicalAddress = ko.observable();

    this.Load = () => {

        LocationApi.getLocationData().then(data => {
            let newData = data.data;
            let workAddress = newData.addresses.find(addr => addr.addressType === 'Work');
            const workPhone = newData.phoneNumbers.filter(p => p.phoneNumberTypeID === 'Work');
            workAddress.formattedAddress = formatAddress(workAddress);
            workAddress.formattedPhone = formatPhoneNumber(workPhone[0].thePhoneNumber);
            this.location(newData);
            this.physicalAddress(workAddress);
        });

        LocationApi.getLocationLogo().then(data => {
            this.logoUrl(data.data);
        });
    };
    this.Load();

    return this;
};